/**
 * This static list is shared by telemetry bootstrapping and event filtering.
 * Keep it local because observability initializes before external configuration
 * can be fetched safely.
 */
export const O11Y_BLOCK_LIST_ORG_IDS = [
    // Reserved placeholder
    'cccccccc-beee-4dee-beee-badbeeeeeeee',
];
export function isOrganizationBlockedFromTelemetry(orgId) {
    return orgId !== undefined && O11Y_BLOCK_LIST_ORG_IDS.includes(orgId);
}
//# sourceMappingURL=o11yBlockList.js.map